<router-outlet></router-outlet>

@if (isDev) {
  <div class="ng-version-badge">Angular {{ angularVersion }}</div>
}
